import React, { useCallback } from 'react';
import _ from 'lodash';
import { generateOpenColorPicker } from '../../sections/utils';
import { Shadow } from '../../adapters/types';
import { SiteColorMap } from '../../types';
import { ShadowInput } from '../../sections/Components';
import { DEBOUNCE_TIME } from '../../sections/constants';

type ShadowsPanelProps = {
  shadow: Shadow;
  onChangeShadow: (shadow: Shadow) => void;
  openColorPicker: ReturnType<typeof generateOpenColorPicker>;
  siteColorMap: SiteColorMap;
};

const ShadowsPanel = ({
  shadow,
  onChangeShadow,
  openColorPicker,
  siteColorMap,
}: ShadowsPanelProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onChangeDebounced = useCallback(
    _.debounce(onChangeShadow, DEBOUNCE_TIME, { trailing: true }),
    [],
  );

  return (
    <ShadowInput
      shadow={shadow}
      onChange={onChangeShadow}
      onChangeDebounced={onChangeDebounced}
      openColorPicker={openColorPicker}
      siteColorMap={siteColorMap}
      layersMode
    />
  );
};

export default ShadowsPanel;
